import React from "react";
import { FaLink, FaGem, FaFileContract, FaProjectDiagram } from "react-icons/fa";

function BlockchainIntegration() {
  return (
    <div>
      <div className="services-style-two-area default-padding">
        <div className="shape">
          <img
            src="assets/img/thumb/ai_optimized_img.png"
            alt="Image Not Found"
          />
        </div>

        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4 col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Services</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Key Features of Blockchain Game Development
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4">
              <div className="services-style-four-items">

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaLink size={45} />
                  </div>
                  <h4>Blockchain Integration</h4>
                  <p>
                    Blockchain seamlessly integrates digital assets, allowing
                    players to own and trade their in-game items securely. Our
                    blockchain solutions address current gamification issues by
                    streamlining transactions and creating genuine digital
                    assets for both players and developers.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaGem size={45} />
                  </div>
                  <h4>Ownership of Digital Assets</h4>
                  <p>
                    Non-fungible tokens (NFTs) revolutionize ownership in gaming
                    by transforming in-game items into unique assets. Players
                    now have the freedom to truly own, trade, and benefit from
                    their digital possessions.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaFileContract size={45} />
                  </div>
                  <h4>Smart Contracts</h4>
                  <p>
                    Smart contracts bring transparency and fairness to in-game
                    transactions. By enabling verification of dealer win rates,
                    smart contracts boost trust in games where outcomes matter,
                    all while adding value to every transaction.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaProjectDiagram size={45} />
                  </div>
                  <h4>Optimized Blockchain Design</h4>
                  <p>
                    Our game architecture employs distributed ledgers for faster
                    block validation and ensures a secure gaming experience with
                    privacy-focused, optimized frameworks.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default BlockchainIntegration;